import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
import { Link } from '@/components/links';
import { mergeClasses } from '@/utils/style';
import { showChristmasOffer } from '@/utils/christmas';
import { showSpringOffer } from '@/utils/springOffer';
import { SPRING_OFFER_TRANSLATION_VALUES } from '@/constants/springOffer';
import { CHRISTMAS_TRANSLATION_VALUES } from '@/constants/christmas';

interface Props {
	variant?: 'withPostponeDueDateInfo';
	className?: string;
}

export function RepresentativeExample(props: Props): React.JSX.Element {
	const { t } = useTranslation('core');

	return (
		<div className={mergeClasses('rounded-2xl bg-blue-50 p-4', props.className)}>
			<Text variant="p4" className="text-center text-gray-700">
				<Trans t={t} i18nKey="representativeExample.1">
					<strong className="text-semibold" />
				</Trans>
				{props.variant === 'withPostponeDueDateInfo' && (
					<>
						{' '}
						<span className="block">
							<Trans t={t} i18nKey="representativeExample.2">
								<Link
									to={LINKS().postponeDueDate}
									testId="revolvingLoanPostponeDueDate"
									analyticsParam="revolvingLoanPostponeDueDate"
									className="block"
								/>
							</Trans>
						</span>
					</>
				)}
			</Text>
			{showChristmasOffer() && (
				<Text variant="p4" className="text-center text-gray-700">
					<Trans t={t} i18nKey="representativeExample.3" values={CHRISTMAS_TRANSLATION_VALUES} />
				</Text>
			)}
			{showSpringOffer() && (
				<Text variant="p4" className="text-center text-gray-700">
					<Trans t={t} i18nKey="representativeExample.4" values={SPRING_OFFER_TRANSLATION_VALUES} />
				</Text>
			)}
		</div>
	);
}
